import React from 'react';
import joinUs from '../../assets/images/join-us-img.png'
import arrowWhite from '../../assets/images/arrow-white.svg'

const JoinUs = () => {
  return ( 
    <div className="jobs bg-light-green">
      <div className="row">
        <div className="col-md-8">
          <p className="text-primary fs-52 font-weight-thin">If you have the drive,<br></br>We have the job.</p>
          <p className="fs-14 text-gray">Build intelligent transport systems that<br></br> guide the way to a safer future</p>
        </div>
        <div className="col-md-3 bg-secondary join-us-outer">
          <div className="join-us text-white">
            <p className="fs-36">Join Us.</p>
            <p>Make a difference in the world -<br></br> one ride at a time</p>
            <div className="text-right"><img src={arrowWhite} alt="White Arrow"></img></div>
          </div>
        </div>
      </div>
      <div className="img-wrapper">
        <img src={joinUs} alt="Join Us" className="join-us-img" />
      </div>
    </div>
   );
}
 
export default JoinUs;